import { Component, Input } from '@angular/core';
@Component({
  selector: 'co-active-patron',
  templateUrl: 'co-active-patron.html'
})
export class CoActivePatronComponent {

 @Input() patron: any;

}


// WEBPACK FOOTER //
// ./src/components/co-active-patron/co-active-patron.ts